import Banner from '@components/Banner/banner';
import BrandSuitabilityFive from './sections/BrandSuitabilityFive';
import BrandSuitabilityFour from './sections/BrandSuitabilityFour';
import BrandSuitabilityOne from './sections/BrandSuitabilityOne';
import BrandSuitabilityThree from './sections/BrandSuitabilityThree';
import BrandSuitabilityTwo from './sections/BrandSuitabilityTwo';
import Footer from '@components/Footer/Footer';
import { useTranslation } from 'react-i18next';

function BrandSuitability() {
  const { t } = useTranslation('brandSuitability');
  return (
    <>
      <Banner
        title={t('brandSuitability.title')}
        paragraph={t('brandSuitability.subtitle')}
      />
      <BrandSuitabilityOne />
      <BrandSuitabilityTwo />
      <BrandSuitabilityThree />
      <BrandSuitabilityFour />
      <BrandSuitabilityFive />
      <Footer />
    </>
  );
}

export default BrandSuitability;
